// ─── Colour palette ─────────────────────────────────────────────────────────
export const ROOT_PALETTES = [
  { ring: '#60aee0', bg: '#e8f4fd', text: '#1a5f8a', pill: '#c5e4f7', pillText: '#1a5f8a' },
  { ring: '#8b72dc', bg: '#eeebfd', text: '#4a2fa0', pill: '#d8d0f9', pillText: '#4a2fa0' },
  { ring: '#3db58a', bg: '#e3f5f0', text: '#1a6b50', pill: '#bce8d8', pillText: '#1a6b50' },
  { ring: '#e0a030', bg: '#fdf4e3', text: '#7a4f10', pill: '#f5dfa0', pillText: '#7a4f10' },
  { ring: '#e05c7a', bg: '#fdeaed', text: '#8a1a38', pill: '#f5c5d0', pillText: '#8a1a38' },
];

export const NEUTRAL = { ring: '#9ca3af', bg: '#f3f4f6', text: '#374151', pill: '#e5e7eb', pillText: '#374151' };

export type Pal = typeof NEUTRAL;

export function lighten(hex: string, t: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const m = (c: number) => Math.round(c + (255 - c) * t).toString(16).padStart(2, '0');
  return `#${m(r)}${m(g)}${m(b)}`;
}

export function getPalette(rootIdx: number, depth: number): Pal {
  const base = ROOT_PALETTES[rootIdx % ROOT_PALETTES.length];
  if (depth === 0) return base;
  return { ...base, bg: lighten(base.bg, 0.35), pill: lighten(base.pill, 0.3) };
}
